import { render, staticRenderFns } from "./News.vue?vue&type=template&id=e96ee016&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=e96ee016&prod&lang=css"
import style1 from "./News.vue?vue&type=style&index=1&id=e96ee016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ee016",
  null
  
)

export default component.exports